import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Slider from '../Slider';
import FilterOverlay from './FilterOverlay';
import FilterHeading from './FilterHeading';
import breakpoints from '../Theme/breakpoints';
import IconButton from '../Button/IconButton';
import Clear from '../Icons/Clear';
import colors from '../Theme/colors';

const RangeFilterWrapper = styled.div<{ loadingProp?: boolean }>`
  margin: 0 0 8px;
  overflow: visible;
  filter: blur(${({ loadingProp }) => (loadingProp ? '2px' : '0px')});

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 16px;
  }
`;

const RangeSliderWrapper = styled.div`
  margin: 20px 0 0;
  padding: 0 16px;
  @media (min-width: ${breakpoints.md}px) {
    padding: 0 12px;
  }
`;

const RangeSlider = styled(Slider)`
  overflow: visible;
`;

const RangeHeaderWrapper = styled.div`
  display: flex;
`;

const StyledIconButton = styled(IconButton)`
  z-index: 2;
`;

const rangeFilterProperties = {
  title: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  showClear: PropTypes.bool,
  onClear: PropTypes.func,
};

type RangeFilterProperties = InferProps<typeof rangeFilterProperties> & {
  loading?: boolean;
  onClear?: () => void;
};

const RangeFilter = ({
  title,
  min,
  max,
  loading = false,
  showClear = true,
  onClear,
  ...properties
}: RangeFilterProperties) => (
  <RangeFilterWrapper loadingProp={loading}>
    { loading && <FilterOverlay /> }
    <RangeHeaderWrapper>
      <FilterHeading tag="h2" modal>
        {title}
      </FilterHeading>
      {showClear && (
        <StyledIconButton
          ariaLabel="Clear Price"
          onClick={onClear}
        >
          <Clear fill={colors.primary} />
        </StyledIconButton>
      )}
    </RangeHeaderWrapper>
    <RangeSliderWrapper>
      <RangeSlider
        min={min}
        max={max}
        {...properties}
      />
    </RangeSliderWrapper>
  </RangeFilterWrapper>
);

RangeFilter.propTypes = rangeFilterProperties;

export default RangeFilter;
